export default "__VITE_ASSET__Bq5$fGKQ__"